// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/4b07a118a9184c0515af.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"18c94296e10303eb8810","175":"5a08c3f85e521f2654fb","176":"1caa9648ef899287af6b"}[chunkId] + ".chunk.js";
};